class Modals {
  $modal = null
  constructor () {
    this.init()
  }

  init () {
    this.$modal = $('.modal')
    $('.infobulle-link').click(event => {
      event.preventDefault()
      this.openModal($(event.currentTarget).data('id'))
    })

    this.$modal.find('.modal-close').click(() => {
      this.closeModal()
    })

    $(document).keydown(event => {
      if (event.key === 'Escape') {
        this.closeModal()
      }
    })

    // this.openModal('favoris-not-logged-in')
  }

  openModal (modalId, event) {
    this.$modal.find('#' + modalId).removeClass('hidden')
    this.$modal.fadeIn(500)
    $('html').css('overflow-y', 'hidden')
    $('body').addClass('open-modal')
    this.$modal.addClass('open')
  }

  closeModal () {
    this.$modal.removeClass('open')
    this.$modal.fadeOut(500, () => {
      this.$modal.find('.modal-content-item').addClass('hidden')
      $('html').css('overflow-y', 'auto')
      $('body').removeClass('open-modal')
    })
  }
}

export default Modals
